const UNLIMITED_APPLICATION_TYPE_LIMIT = -1;
export function normalizeTpApplicationTypeLimit(limit) {
    if (!Number.isFinite(limit)) {
        return UNLIMITED_APPLICATION_TYPE_LIMIT;
    }
    return limit;
}
export function getSelectedTpApplicationTypeCount(selectedTypes) {
    if (!Array.isArray(selectedTypes) || selectedTypes.length === 0) {
        return 0;
    }
    return selectedTypes.reduce((selectedCount, selectedType) => {
        const selectedValue = getSelectedLookupValue(selectedType);
        if (!selectedValue) {
            return selectedCount;
        }
        return selectedCount + 1;
    }, 0);
}
export function mapTpApplicationTypeLimitToUiState(applicationTypeLimit, currentCount) {
    const normalizedLimit = normalizeTpApplicationTypeLimit(applicationTypeLimit);
    const normalizedCount = normalizeSelectedCount(currentCount);
    const isUnlimited = normalizedLimit <= 0;
    const isSingleTypeSelection = normalizedLimit === 1;
    const hasReachedLimitedCount = !isUnlimited && normalizedLimit > 1 && normalizedCount >= normalizedLimit;
    return {
        normalizedLimit,
        currentCount: normalizedCount,
        isUnlimited,
        hideButtons: isSingleTypeSelection,
        disableAdd: hasReachedLimitedCount,
        fullWidthDropdown: isSingleTypeSelection
    };
}
function normalizeSelectedCount(currentCount) {
    if (!Number.isFinite(currentCount) || currentCount <= 0) {
        return 0;
    }
    return Math.floor(currentCount);
}
function getSelectedLookupValue(selectedType) {
    if (typeof selectedType === "string") {
        const trimmedValue = selectedType.trim();
        return trimmedValue.length > 0 ? trimmedValue : null;
    }
    if (selectedType !== null && typeof selectedType === "object" && "value" in selectedType) {
        const valueProperty = selectedType.value;
        if (typeof valueProperty !== "string") {
            return null;
        }
        const trimmedValue = valueProperty.trim();
        return trimmedValue.length > 0 ? trimmedValue : null;
    }
    return null;
}
